var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Tabs',[_c('TabPane',{attrs:{"label":"转化漏斗"}})],1),_c('div',{staticClass:"t-charts-wrapper"},[_c('div',{style:({width:_vm.chartsWidth+'px',height:_vm.chartHeight+'px'}),attrs:{"id":"tranferchart"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }